const history = {
    navigate: null,
    location: null
};

export default history;
